import Colors from "../../../theme/colors";

const style = {
  container: {
    backgroundColor: "#FFFFFF",
    // border: "1px solid #0000001A",
    borderRadius: "8px",
    // height: "100",
  },
  search: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
  },
  searchInput: {
    width: "40%",
    // border: "1px solid #A4A4A4",
    borderRadius: "0.5rem",
  },
  tableContainer: {
    backgroundColor: Colors.white,
    // border: "1px solid red",
    // textAlign: "center",
    // position: "relative",
    // overflowX: "scroll",
  },
  tableTitle: {
    color: "#8C8C8C",
    fontSize: "1.2rem",
    fontWeight: 500,
    marginBottom: "1rem",
    // border: "1px solid red",
  },
  tableHeading: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
    color: "#8C8C8C",
    whiteSpace: "nowrap",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    // border: "1px solid red",
  },
  tableRow: {
    backgroundColor: "#FFFFFF",
    // border: "1px solid red",
    color: "#183053",
    // textAlign: "center",
    // whiteSpace: "nowrap",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
  },
  applyButton: {
    color: "#043D90",
    border: "1px solid #043d90",
    borderRadius: "0.5rem",
    padding: "0.3rem 1.5rem",
    fontWeight: 500,
  },
  disableButton: {
    color: "#8C8C8C",
    border: "1px solid #8C8C8C",
    borderRadius: "0.5rem",
    padding: "0.3rem 1.5rem",
    fontWeight: 500,
  },
  searchButton: {
    color: "#FFFFFF",
    borderRadius: "0.5rem",
    padding: "0.5rem 3rem",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  rowStyleId: {
    color: "#043D90",
    fontWeight: 500,
  },
  rowStyle: {
    color: "#183053",
    textAlign: "center",
  },
  customTable: {
    border: "none",
  },
  rowStyleInfo: {
    display: "flex",
    // border: "1px solid red",
  },
  searchDropdown: {
    width: "40%",
    border: "1px solid #A4A4A4",
    borderRadius: "0.5rem",
  },
  mediumItem: {
    flex: "1 1 28%",
  },
  existingGZ: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 10,
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },
  noDataMsg: {
    color: "red",
  },
  text: {
    fontWeight: 400,
    fontSize: 18,
    color: "#171B5E",
    textAlign: "center",
    marginTop: 10,
  },
  initialContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    margin: "60px 0px",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default style;
